import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface Props {
  allowedRoles: string[];
}

export function homePathForRole(role: string | undefined, isSuperuser?: boolean): string {
  if (isSuperuser || role === "admin") return "/admin";
  if (role === "physician") return "/physician";
  if (role === "test_administrator") return "/physician";
  return "/doctor";
}

export default function RoleGuard({ allowedRoles }: Props) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  if (user.is_superuser || allowedRoles.includes(user.role)) {
    return <Outlet />;
  }

  return <Navigate to={homePathForRole(user.role, user.is_superuser)} replace />;
}
